import { HelpButton } from "src/base-components/HelpButton";

export const FormStepWrapper: React.FC<{
  children: React.ReactNode;
  title: string;
  description: string;
  actions?: React.ReactNode;
  docLink?: string;
}> = ({ children, title, description, actions, docLink }) => {
  return (
    <div
      className="max-w-4xl"
      data-loc="case-template-version-form-step-content"
    >
      <div className="rounded-lg border border-gray-200 bg-white">
        <CaseTemplateStepFormHeadline
          actions={actions}
          description={description}
          docLink={docLink}
          title={title}
        />

        <div className="space-y-3 p-4">{children}</div>
      </div>
    </div>
  );
};

const CaseTemplateStepFormHeadline: React.FC<{
  title: string;
  description: string;
  actions?: React.ReactNode;
  docLink?: string;
}> = ({ title, description, actions, docLink }) => {
  return (
    <div className="flex flex-col gap-y-2 border-gray-200 border-b p-4">
      <div className="flex items-center justify-between">
        <h2
          className="font-inter-semibold-13px"
          data-loc="case-template-version-step-title"
        >
          {title}
        </h2>
        <div className="flex items-center gap-x-2">
          {docLink && <HelpButton url={docLink} />}
          {actions}
        </div>
      </div>
      <p
        className="font-inter-normal-12px text-gray-500"
        data-loc="case-template-version-step-description"
      >
        {description}
      </p>
    </div>
  );
};
